import React, { useEffect, useState } from "react";
import { BoldIcon, ErrorIcon, ItalicIcon } from "../../assets/icons/Icons";
import { FormikType } from "../../types/types";
import { InitialAuditionStateType } from "../../assets/data/initialState";
import { HtmlTextInput } from "../Components";

export type Props = FormikType<InitialAuditionStateType>;

export default function AuditionDescription({ formik }: Props) {
  return (
    <div className="pb-8">
      <p className="font-Switzer font-bold text-2xl tracking-tight mb-1 color-black">
        Audition Description
      </p>
      <p className="font-Switzer text-base tracking-tight mb-3 color-black">
        Include a thorough description of the part and audition. This makes it
        clearer for the user to understand what the audition is for.
      </p>
      <HtmlTextInput
        text={formik.values.description}
        onChange={(text) => formik.setFieldValue("description", text)}
      />
      {formik.touched.description && formik.errors.description && (
        <div
          className="w-full mt-5 flex items-center font-medium text-lg text-ErrorRed"
          role="alert"
        >
          <ErrorIcon className="mr-2" width={"28"} height={"28"} />
          {formik.errors.description}
        </div>
      )}
    </div>
  );
}
